import React from "react";
import { TranslationText } from "components/TextTranslationContainer";
import useGoogleApi from "./useGoogleApi";
import { StarRating } from "components";
import { WithTransparentSpinner } from "components/Hoc/WithTransparentSpinner";

const GoogleReview = () => {
  const [rating, setRating] = React.useState(4.5);
  const [hoverValue, setHoverValue] = React.useState(4.5);

  const { placeInfo, isLoaded } = useGoogleApi();

  const handleRatingChange = (value) => {
    setRating(value);
    window.open(`https://search.google.com/local/writereview?placeid=${placeInfo?.place_id}&rating=${value}`, "_blank");
  }

  return (
    <>
    <WithTransparentSpinner loading={!isLoaded}/> 
    <div className="flex items-center gap-2 flex-col my-5 py-4">
      <TranslationText text="How was your experience?" className="text-20x font-bold text-brand-base-primary" />
      <TranslationText text="We’d love to hear your feedback." className="text-16x font-medium text-shadow-forge-900" />
      <StarRating
        size={40}
        rating={rating}
        hoverValue={hoverValue}
        onHoverChange={setHoverValue}
        onRatingChange={handleRatingChange}
        interactive
      />
    </div>
    </>
  );
};

export default GoogleReview;
